import React from 'react'
import { Container } from 'react-grid-system'

import BannerWebFallback from 'assets/img/banner3_web_fallback.jpg'
import BannerMobileFallback from 'assets/img/banner3_mobile_fallback.jpg'

import { useMobile } from 'utils/mobile'

import Image from 'components/Image'

import './ProjectInfoBanner.scss'
import { TagPushHome } from 'analytics/home'

const ProjectInfoBanner = ({ bankName }) => {
    const mobile = useMobile()

    return (
        <div className="project-info-banner">
            <Container className="project-info-banner__container">
                <a
                    href="https://video.bot/zkiyBb0"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => TagPushHome.interactionBannerClick(bankName)}
                >
                    {mobile ? (
                        <Image
                            id="productDetailsBanner"
                            src="https://www.alelo.com.br/content/dam/ecommerce/banners/Banner3_mob.jpg"
                            errorSrc={BannerMobileFallback}
                            alt="Project info banner"
                        />
                    ) : (
                        <Image
                            id="productDetailsBanner"
                            src="https://www.alelo.com.br/content/dam/ecommerce/banners/Banner3_desk.jpg"
                            errorSrc={BannerWebFallback}
                            alt="Project info banner"
                        />
                    )}
                </a>
            </Container>
        </div>
    )
}

export default ProjectInfoBanner
